/**
 * @generated SignedSource<<eaed9865a7e88310fd4236f4e49f68f8>>
 * @relayHash a8f662ea3948cbf66f23cd060b8803dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2ccc5bea86cc33406aa32467d323c904c73f7bdc731e44dfb1f2b74b491a4c92

import type { ConcreteRequest } from 'relay-runtime';
export type ObjectCommentResolveCommentMutation$variables = {
  cloudId: string;
  commentIds: ReadonlyArray<string | null | undefined>;
};
export type ObjectCommentResolveCommentMutation$data = {
  readonly confluence_resolveComments: {
    readonly commentResolutionStates: ReadonlyArray<{
      readonly commentId: string;
      readonly resolveProperties: {
        readonly resolvedFriendlyDate: string | null | undefined;
        readonly resolvedTime: AGG$Long | null | undefined;
        readonly resolvedUser: string | null | undefined;
      } | null | undefined;
      readonly status: boolean | null | undefined;
    } | null | undefined> | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly __typename: "ResolveCommentsMutationErrorExtension";
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type ObjectCommentResolveCommentMutation = {
  response: ObjectCommentResolveCommentMutation$data;
  variables: ObjectCommentResolveCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentIds"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "commentIds",
    "variableName": "commentIds"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "concreteType": "ConfluenceCommentResolutionState",
  "kind": "LinkedField",
  "name": "commentResolutionStates",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "commentId"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "resolveProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "resolvedTime"
        },
        {
          "kind": "ScalarField",
          "name": "resolvedUser"
        },
        {
          "kind": "ScalarField",
          "name": "resolvedFriendlyDate"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "errorType"
    },
    {
      "kind": "ScalarField",
      "name": "statusCode"
    }
  ],
  "type": "ResolveCommentsMutationErrorExtension"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ObjectCommentResolveCommentMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "ConfluenceResolveCommentsPayload",
        "kind": "LinkedField",
        "name": "confluence_resolveComments",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ObjectCommentResolveCommentMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "ConfluenceResolveCommentsPayload",
        "kind": "LinkedField",
        "name": "confluence_resolveComments",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a8f662ea3948cbf66f23cd060b8803dd",
    "id": "2ccc5bea86cc33406aa32467d323c904c73f7bdc731e44dfb1f2b74b491a4c92",
    "metadata": {},
    "name": "ObjectCommentResolveCommentMutation",
    "operationKind": "mutation",
    "text": "mutation ObjectCommentResolveCommentMutation($commentIds:[ID]!,$cloudId:ID!){confluence_resolveComments(commentIds:$commentIds,cloudId:$cloudId){success,commentResolutionStates{commentId,resolveProperties{resolvedTime,resolvedUser,resolvedFriendlyDate},status},errors{message,extensions{...on ResolveCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "b22b5ff3d19850498d8af166b371db75";

export default node;
